export default {"src":"/_next/static/media/lune-icon-biofuel.22fbf044.svg","height":144,"width":144,"blurWidth":0,"blurHeight":0};